<template>
<div class="common-box nav-box" :class="{'navwhite' : navIsWhite}">
     <div class="d-navbar" >
            <div class="d-navbar-logo" @click="goHome">
               <img src="../assets/logo.png" alt="">
            </div>
            <div class="d-navbar-list">
                 <ul>
                    <li v-for="(item,index) in navList" :key="index" @click="setDotted(index)">
                        <router-link :to="item.href" >{{item.title}}</router-link>
                    </li>
                </ul>
                <div  class="d-btn" @click="setDotted(5);showLogin()">
                    免费试用
                </div>
            </div>
    </div>
</div>
</template>

<script>
export default {
    props:['navIsWhite'],
  data() {
    return {
      navList: [
        { title: "首页", href: "/" },
        { title: "产品介绍", href: "/product" },
        { title: "购买与服务", href: "/service" },
        { title: "合作伙伴", href: "/partner" },
        { title: "帮助", href: "/help" },
      ],
    };
  },
  methods:{
     
  },
  methods:{
    setDotted(index) {
      console.log(index)
      switch (index) {
          case 0 :
            _czc.push(["_trackEvent","顶部导航栏标签_首页", "tab标签"]);
          break;
           case 1 :
            _czc.push(["_trackEvent","顶部导航栏标签_产品介绍", "tab标签"]);
          break;
           case 2 :
            _czc.push(["_trackEvent","顶部导航栏标签_购买与服务", "tab标签"]);
          break;
           case 3 :
            _czc.push(["_trackEvent","顶部导航栏按钮_帮助", "tab标签"]);
          break;
           case 4 :
            _czc.push(["_trackEvent","顶部导航栏标签_合作伙伴", "tab标签"]);
          break;
           case 5 :
             _czc.push(["_trackEvent","顶部导航栏按钮_免费试用", "tab-button"]);
          break;
      }
    },
    goHome(){
      this.$router.push('/')
    },
    showLogin(){
      this.$root.$emit('change',true)
    }
  }
};
</script>

<style lang="less">
.nav-box{
  position: fixed;
  top: 0px;
  left:0;
  right:0;
  z-index:99;
}
.d-navbar {
 width:1200px;
  height: 70px;
  line-height: 70px;
  background: transparent;
  display: flex;
  justify-content: space-between;
  z-index: 100;
  transition: all 0.3s;
  margin:0 auto;
  font-weight:normal;
  .d-navbar-logo{
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  &-list {
    display:flex;
  align-items: center;
    ul{
        overflow: hidden;
        display: inline-block;
    }
    li {
      float: left;
      a {
        display: block;
         font-size: 14px;
        color: #333333;
        padding:0 25px;
        cursor: pointer;
         &:hover{
           color:#4285F4
      }
      }
    }
  }
  .router-link-exact-active {
     color:  #4285F4;
  }
  &-logo{
      img{
        width:322px;
      } 
  }
  .d-btn{
    margin:0;
    border-radius: 18px;
    font-size: 14px;
    text-align: center;
    line-height: 34px;
    text-align:center;
    margin-left:35px;
    font-weight: 300;
    width:92px;
    height:36px;
    // background:linear-gradient(139deg,rgba(127,119,250,1) 0%,rgba(24,111,255,1) 100%);
    border: 1px solid #4285F4;
    cursor: pointer;
    color: #4285F4;
    &:hover{
      background:#4285F4;
      color: #ffffff;
    }
  }
}
.navwhite{
    background: white;
    border-bottom:1px solid  #F2F2F2 ;
    height:70px;
}
@keyframes bganimate {
    from {
      background: white;
    }
    to{
      background:#4285F4;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/d-header.vue